import { scrollSmootherInstance, gsap } from './gsap';
import pageTransition from './pageTransition';

class Header {
	stateClasses = {
		flyoutOpen: 'flyout--open',
		flyoutAnimating: 'flyout--animating',
	};
	isOpen = false;
	options = {
		duration: 1,
		ease: 'cubic-bezier(.165,.84,.44,1)',
	};
	constructor($el) {
		this.$el = $el;
		this.$html = $('html');
		this.$menu = this.$el.find('[data-header="menu"]');
		this.$close = this.$el.find('[data-header="close"]');

		// flyout stuff
		this.$flyout = this.$el.find('[data-header="flyout"]');
		this.$flyoutContent = this.$el.find('[data-header="flyout-content"]');
		this.$links = this.$el.find('[data-header="link"]');
		this.init();
	}

	init = () => {
		this.$menu.on('click', this.toggleFlyout);

		this.initTimeline();
	};

	initTimeline = () => {
		// create a gsap timeline with multiple tweens
		const { duration, ease } = this.options;

		this.tl = gsap.timeline({
			paused: true,
		});

		this.tl.fromTo(
			this.$flyout,
			{
				clipPath: 'inset(0px 0px 0px 100%)',
			},
			{
				duration,
				clipPath: 'inset(0px 0px 0px 0px)',
				ease,
			}
		);

		this.tl.fromTo(
			this.$flyoutContent,
			{
				x: '100%',
			},
			{
				duration: 0.5,
				x: '0%',
				ease,
			},
		);

		// execute something inside the timeline
		this.tl.add(() => {
			this.$html.removeClass(this.stateClasses.flyoutAnimating);
		});

		// stagger the links
		this.tl.fromTo(
			this.$links,
			{
				y: '100%',
			},
			{
				duration: 0.5,
				y: '0%',
				ease,
				stagger: 0.1,
			},
		);
	};

	toggleFlyout = () => {
		if (this.isOpen) {
			pageTransition.animateIn(() => {
				this.closeFlyout();
				pageTransition.animateOut();
			});
		} else {
			this.openFlyout();
		}
	};

	openFlyout = () => {
		this.$html.addClass(this.stateClasses.flyoutAnimating);
		scrollSmootherInstance.paused(true);
		this.$html.addClass(this.stateClasses.flyoutOpen);

		this.tl.play();

		this.isOpen = true;

		// close flyout on escape key
		$(document).one('keyup', e => {
			if (e.key === 'Escape') {
				this.closeFlyout();
			}
		});
	};

	closeFlyout = (animate = false) => {
    this.setCloseProperties();

    if(animate) {
      this.tl.reverse();
    } else {
      this.tl.progress(0);
    }

    this.tl.reverse();

		// remove escape key listener
		$(document).off('keyup');
	};

  setCloseProperties = () => {
    this.$html.removeClass(this.stateClasses.flyoutOpen);
		scrollSmootherInstance.paused(false);
		this.isOpen = false;
  };
}

export default new Header($('[data-header="el"]'));
